// extracted by mini-css-extract-plugin
export var languageButton = "LanguageSelector-module--languageButton--CiFfh";
export var languagePicker = "LanguageSelector-module--languagePicker--hq3VE";
export var root = "LanguageSelector-module--root--kJF6q";
export var show = "LanguageSelector-module--show--owEwW";